import { ChevronDown } from 'lucide-react';
import { Reveal } from '@/components/ui/reveal';
import { LANDING_FAQ } from '@/seo/meta';

/**
 * Visible FAQ. Uses the same questions/answers as the FAQPage structured data
 * (seo/meta.ts) so the markup always matches what users see. <details> keeps the
 * answers in the HTML for crawlers even while collapsed.
 */
export function FaqSection() {
  return (
    <section id="faq" aria-labelledby="faq-title" className="scroll-mt-20 py-20">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <h2 id="faq-title" className="text-center font-display text-3xl font-bold sm:text-4xl">
            Restaurant website grader FAQ
          </h2>
          <p className="mt-3 text-center text-lg text-ink-600">
            Common questions about grading and improving your restaurant’s website.
          </p>
        </Reveal>
        <div className="mt-10 space-y-3">
          {LANDING_FAQ.map((f, i) => (
            <Reveal key={f.q} delay={i * 80}>
              <details className="group rounded-2xl bg-white ring-1 ring-ink-200 transition-shadow duration-300 open:shadow-lg hover:shadow-md">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 p-5 font-semibold text-ink-900 [&::-webkit-details-marker]:hidden">
                  <h3 className="text-base">{f.q}</h3>
                  <ChevronDown
                    className="size-5 shrink-0 text-ink-400 transition-transform duration-300 group-open:rotate-180"
                    aria-hidden
                  />
                </summary>
                <p className="animate-fade-in px-5 pb-5 text-ink-600">{f.a}</p>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
